export enum purchaseTypeEnum {
  销售采购 = 1,
  行政采购 = 2,
}
